/* eslint-disable  */

import { AutocompleteGeneric } from './ac-generic';
import { WOOSMAP_KEY, IS_WOOSMAP_ADVANCED } from '@/modules-es5/commons/lib/lib-stores';

export class AutocompleteWoosmap extends AutocompleteGeneric {
  getLibrary() {
    return Promise.resolve();
  }

  // from an 'input' val
  // returns a list a 'suggestions', through the 'resolvePromise' callback
  searchSuggestions(input, resolvePromise) {
    const country = window.tc_vars.env_country.toLowerCase();
    const language = window.tc_vars.env_language;
    const advancedParam = IS_WOOSMAP_ADVANCED ? '&data=advanced' : '';
    cube.ajax
      .get(`https://api.woosmap.com/localities/autocomplete/?input=${input}&key=${WOOSMAP_KEY}&components=country:${country}&language=${language}${advancedParam}`)
      .onSuccess(data => {
        const result = data;
        resolvePromise(result.localities)
      })
      .call()
  }

  // from a 'suggestion'
  // returns a detailed 'position', through the 'resolvePromise' callback
  searchPosition(suggestion, resolvePromise) {
    resolvePromise({
      name: suggestion.name,
      latitude: suggestion.location.lat,
      longitude: suggestion.location.lng,
    });
  }
}



// WEBPACK FOOTER //
// ./src/commons/component/autocomplete/ac-woosmap.js